import React, { useState } from 'react'

import { useScroll } from '../../hooks'

import Logo from './logo.png'
import {
  StyledHeader,
  StyledWrapper,
  NavItem,
  NavWrap,
  IconWrap,
  MenuIcon,
  CloseIcon,
  MobileTextLine,
  MobileMenuContainer,
} from './atoms'

const navList = [
  { link: '/', text: '首页' },
  { link: '/iaas/', text: 'IAAS解决方案' },
  { link: '/paas/', text: 'PAAS解决方案' },
  // { link: '/demo/', text: '体验中心' },
  { link: '/about/', text: '关于我们' },
]

function Header() {
  const [left, setLeft] = useState(0)
  const [stick, setStick] = useState(true)
  const [showMenu, setShowMenu] = useState(false)
  function handleScroll(e) {
    setLeft(-e.target.scrollingElement.scrollLeft)
    setStick(document.scrollingElement.scrollTop === 0)
  }
  function handleMenuClick() {
    setShowMenu(!showMenu)
  }
  useScroll(handleScroll)
  return (
    <StyledHeader style={{ left }} stick={stick}>
      <StyledWrapper>
        <img src={Logo} alt='' />
        <NavWrap>
          {navList.map((item, idx) => (
            <NavItem key={idx} to={item.link}>
              {item.text}
            </NavItem>
          ))}
        </NavWrap>
        <IconWrap onClick={handleMenuClick}>
          <MenuIcon isActive={!showMenu} />
          <CloseIcon isActive={showMenu} />
        </IconWrap>
        <MobileMenuContainer isExpand={showMenu}>
          {navList.map((item, idx) => (
            <MobileTextLine key={idx} to={item.link}>
              {item.text}
            </MobileTextLine>
          ))}
        </MobileMenuContainer>
      </StyledWrapper>
    </StyledHeader>
  )
}

export default Header
